import React, { Component } from "react";
import { connect } from "react-redux";
import { loginWithFacebook } from "../../actions/userActions";
import "./index.css";
import { Icon } from "semantic-ui-react";

class FirebaseLogin extends Component {
  render() {
    const className = this.props.className ? this.props.className : `fb-login ${this.props.slim ? "-slim" : ""}`;
    return (
      <div className={className} onClick={this.props.loginWithFacebook}>
        {this.props.children ? this.props.children : <Icon name="facebook official" size="large" />}
        Connect with Facebook
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  loginWithFacebook: user => dispatch(loginWithFacebook(user)),
});
export default connect(null, mapDispatchToProps)(FirebaseLogin);



// WEBPACK FOOTER //
// ./src/components/FirebaseLogin/index.js